import { render, staticRenderFns } from "./SenderInformation.vue?vue&type=template&id=4d692065&"
import script from "./SenderInformation.vue?vue&type=script&lang=js&"
export * from "./SenderInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports